var _mask, _mask2, _mask3, _mask4, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDraggable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 13 14",
    width: 13,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 4,
    maskUnits: "userSpaceOnUse",
    width: 8,
    x: 2,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2.66447v6.90986h-2.66447z",
    fill: "#d9d9d9",
    transform: "matrix(0 -1 -1 0 9.61719 3.17725)"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 8,
    maskUnits: "userSpaceOnUse",
    width: 4,
    x: 9,
    y: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2.66447v6.90986h-2.66447z",
    fill: "#d9d9d9",
    transform: "matrix(1 .00000004 .00000004 -1 9.92432 10.1304)"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    height: 4,
    maskUnits: "userSpaceOnUse",
    width: 8,
    x: 2,
    y: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2.66447v6.90986h-2.66447z",
    fill: "#d9d9d9",
    transform: "matrix(-.00000001 1 1 .00000001 2.9707 10.4375)"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    height: 8,
    maskUnits: "userSpaceOnUse",
    width: 3,
    x: 0,
    y: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2.66447v6.90986h-2.66447z",
    fill: "#d9d9d9",
    transform: "matrix(-1 -.00000006 -.00000006 1 2.66455 3.4834)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.29395 3.76879v-.89638-1.50229",
    stroke: "#d5001c",
    strokeWidth: 0.6525
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.31445 4.23275-3.02083-3.02084-3.02083 3.02084",
    stroke: "#d5001c",
    strokeWidth: 0.6525
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.29434 6.80713h.93486 1.5022",
    stroke: "#d5001c",
    strokeWidth: 0.6525
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.86882 9.82812 3.02078-3.02083-3.02078-3.02083",
    stroke: "#d5001c",
    strokeWidth: 0.6525
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.29443 9.80982v.93298 1.5023",
    stroke: "#d5001c",
    strokeWidth: 0.6525
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.27344 9.382 3.02083 3.0208 3.02083-3.0208",
    stroke: "#d5001c",
    strokeWidth: 0.6525
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m3.26494 6.80664h-.90523-1.502288",
    stroke: "#d5001c",
    strokeWidth: 0.6525
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.72005 3.78613-3.020831 3.02084 3.020831 3.02083",
    stroke: "#d5001c",
    strokeWidth: 0.6525
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/draggable.b7952a3a0a9897c99bba5ecbf9a3b88f.svg";
export { ForwardRef as ReactComponent };